import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDoubleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronDoubleLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0001 6.93945L4.93945 12.0001L10.0001 17.0608L11.0608 16.0001L7.06077 12.0001L11.0608 8.00011L10.0001 6.93945Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M17.0001 6.93945L11.9395 12.0001L17.0001 17.0608L18.0608 16.0001L14.0608 12.0001L18.0608 8.00011L17.0001 6.93945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDoubleLeft;
